(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["he-annoucement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('he-announcement-bar')) {
    class HEAnnouncementBar extends HTMLElement {
      connectedCallback() {
        if (this._heInitialized) return;
        this._heInitialized = true;
        this._bar = this.querySelector('.he-announcement__bar');
        this._slides = Array.from(this.querySelectorAll('[data-announcement-slide]'));
        this._previousButton = this.querySelector('[data-announcement-previous]');
        this._nextButton = this.querySelector('[data-announcement-next]');
        this._toggleButton = this.querySelector('[data-announcement-toggle]');
        this._status = this.querySelector('[data-announcement-status]');
        this._localizationSelects = Array.from(this.querySelectorAll('[data-localization-select]'));
        if (!this._bar || !this._slides.length) { this._heInitialized = false; return; }

        const initialIndex = this._slides.findIndex((slide) => slide.classList.contains('is-active'));
        this._index = initialIndex >= 0 ? initialIndex : 0;
        this._rotationEnabled = this.dataset.autoplay === 'true';
        this._pauseOnHover = this.dataset.pauseOnHover === 'true';
        this._interval = Math.max(3000, Number(this.dataset.rotationInterval) || 5000);
        this._timer = null;
        this._userPaused = false;
        this._explicitPlay = false;
        this._hoverPaused = false;
        this._focusPaused = false;
        this._motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this._reducedMotion = this._motionQuery.matches;

        this._onPrevious = () => this._show(this._index - 1, 'previous', true);
        this._onNext = () => this._show(this._index + 1, 'next', true);
        this._onToggle = () => {
          if (this._isPaused()) {
            this._userPaused = false;
            this._explicitPlay = true;
            this._hoverPaused = false;
            this._focusPaused = false;
          } else {
            this._userPaused = true;
            this._explicitPlay = false;
          }
          this._syncToggle();
          this._startRotation();
        };
        this._onPointerEnter = () => { if (this._pauseOnHover) { this._hoverPaused = true; this._stopRotation(); } };
        this._onPointerLeave = () => { if (this._pauseOnHover) { this._hoverPaused = false; this._startRotation(); } };
        this._onFocusIn = () => { this._focusPaused = true; this._stopRotation(); };
        this._onFocusOut = (event) => {
          if (!this.contains(event.relatedTarget)) { this._focusPaused = false; this._startRotation(); }
        };
        this._onVisibilityChange = () => { if (document.hidden) this._stopRotation(); else this._startRotation(); };
        this._onMotionChange = (event) => {
          this._reducedMotion = event.matches;
          if (!event.matches) this._explicitPlay = false;
          this._syncToggle();
          this._startRotation();
        };
        this._onLocalizationChange = (event) => {
          const form = event.currentTarget.form;
          if (!form) return;
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.submit();
        };
        this._onBlockSelect = (event) => {
          const sectionId = this.id.replace('he-announcement-', '');
          if (!event.detail || event.detail.sectionId !== sectionId) return;
          const target = event.target && event.target.closest ? event.target.closest('[data-announcement-slide]') : null;
          if (!target) return;
          const index = Number(target.dataset.index);
          if (!Number.isInteger(index)) return;
          this._stopRotation();
          this._show(index, 'next', false);
        };
        this._onBlockDeselect = (event) => {
          const sectionId = this.id.replace('he-announcement-', '');
          if (event.detail && event.detail.sectionId === sectionId) this._startRotation();
        };

        if (this._previousButton) this._previousButton.addEventListener('click', this._onPrevious);
        if (this._nextButton) this._nextButton.addEventListener('click', this._onNext);
        if (this._toggleButton) this._toggleButton.addEventListener('click', this._onToggle);
        this.addEventListener('pointerenter', this._onPointerEnter);
        this.addEventListener('pointerleave', this._onPointerLeave);
        this.addEventListener('focusin', this._onFocusIn);
        this.addEventListener('focusout', this._onFocusOut);
        this._localizationSelects.forEach((select) => select.addEventListener('change', this._onLocalizationChange));
        this._localizationSelects.forEach((select) => this._fitSelect(select));
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => this._localizationSelects.forEach((select) => this._fitSelect(select)));
        }
        document.addEventListener('visibilitychange', this._onVisibilityChange);
        document.addEventListener('shopify:block:select', this._onBlockSelect);
        document.addEventListener('shopify:block:deselect', this._onBlockDeselect);
        if (typeof this._motionQuery.addEventListener === 'function') this._motionQuery.addEventListener('change', this._onMotionChange);
        else this._motionQuery.addListener(this._onMotionChange);

        this._slides.forEach((slide, index) => {
          const active = index === this._index;
          slide.classList.toggle('is-active', active);
          slide.classList.remove('is-leaving');
          slide.setAttribute('aria-hidden', String(!active));
        });
        this._syncToggle();
        this._startRotation();
      }

      disconnectedCallback() {
        this._stopRotation();
        if (!this._heInitialized) return;
        if (this._previousButton) this._previousButton.removeEventListener('click', this._onPrevious);
        if (this._nextButton) this._nextButton.removeEventListener('click', this._onNext);
        if (this._toggleButton) this._toggleButton.removeEventListener('click', this._onToggle);
        this.removeEventListener('pointerenter', this._onPointerEnter);
        this.removeEventListener('pointerleave', this._onPointerLeave);
        this.removeEventListener('focusin', this._onFocusIn);
        this.removeEventListener('focusout', this._onFocusOut);
        this._localizationSelects.forEach((select) => select.removeEventListener('change', this._onLocalizationChange));
        document.removeEventListener('visibilitychange', this._onVisibilityChange);
        document.removeEventListener('shopify:block:select', this._onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this._onBlockDeselect);
        if (this._motionQuery) {
          if (typeof this._motionQuery.removeEventListener === 'function') this._motionQuery.removeEventListener('change', this._onMotionChange);
          else this._motionQuery.removeListener(this._onMotionChange);
        }
        this._heInitialized = false;
      }

      _fitSelect(select) {
        if (window.CSS && CSS.supports && CSS.supports('field-sizing', 'content')) return;
        const option = select.options[select.selectedIndex];
        if (!option) return;
        const cs = window.getComputedStyle(select);
        const probe = document.createElement('span');
        probe.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;pointer-events:none;top:0;left:0;';
        probe.style.font = cs.font;
        probe.style.letterSpacing = cs.letterSpacing;
        probe.textContent = option.textContent.replace(/\s+/g, ' ').trim();
        document.body.appendChild(probe);
        const textWidth = probe.getBoundingClientRect().width;
        probe.remove();
        const padding = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);
        select.style.width = Math.ceil(textWidth + padding) + 'px';
      }

      _isPaused() {
        return !this._rotationEnabled || this._userPaused || (this._reducedMotion && !this._explicitPlay);
      }

      _syncToggle() {
        if (!this._toggleButton) return;
        const paused = this._isPaused();
        this._toggleButton.classList.toggle('is-paused', paused);
        this._toggleButton.setAttribute('aria-pressed', String(paused));
        this._toggleButton.setAttribute('aria-label', paused ? (this.dataset.labelResume || 'Resume announcements') : (this.dataset.labelPause || 'Pause announcements'));
      }

      _startRotation() {
        this._stopRotation();
        if (!this._rotationEnabled || this._slides.length < 2 || this._isPaused() || this._hoverPaused || this._focusPaused || document.hidden) return;
        this._timer = window.setInterval(() => this._show(this._index + 1, 'next', false), this._interval);
      }

      _stopRotation() {
        if (this._timer !== null && this._timer !== undefined) { window.clearInterval(this._timer); this._timer = null; }
      }

      _show(requestedIndex, direction, restartTimer) {
        if (this._slides.length < 2) return;
        const nextIndex = ((requestedIndex % this._slides.length) + this._slides.length) % this._slides.length;
        if (nextIndex === this._index) { if (restartTimer) this._startRotation(); return; }
        const currentSlide = this._slides[this._index];
        const nextSlide = this._slides[nextIndex];
        this._bar.dataset.direction = direction;
        currentSlide.classList.remove('is-active');
        currentSlide.classList.add('is-leaving');
        currentSlide.setAttribute('aria-hidden', 'true');
        nextSlide.classList.remove('is-leaving');
        nextSlide.classList.add('is-active');
        nextSlide.setAttribute('aria-hidden', 'false');
        this._index = nextIndex;
        if (this._status && restartTimer) this._status.textContent = nextSlide.textContent.trim();
        window.setTimeout(() => currentSlide.classList.remove('is-leaving'), 450);
        if (restartTimer) this._startRotation();
      }
    }
    customElements.define('he-announcement-bar', HEAnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["he-categories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('he-category-grid')) {
    class HECategoryGrid extends HTMLElement {
      connectedCallback() {
        if (this._heGridConnected) return;
        this._heGridConnected = true;
        this._observer = null;

        const cards = Array.from(this.querySelectorAll('[data-reveal-card]'));
        const wantsReveal = this.dataset.reveal === 'true';
        const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

        if (!wantsReveal || motionQuery.matches || !('IntersectionObserver' in window)) {
          cards.forEach((card) => card.classList.add('is-revealed'));
          return;
        }

        this.classList.add('he-category-grid--reveal');
        this._observer = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          });
        }, { root: null, threshold: 0.12, rootMargin: '0px 0px -24px 0px' });

        cards.forEach((card) => this._observer.observe(card));
      }

      disconnectedCallback() {
        if (this._observer) {
          this._observer.disconnect();
          this._observer = null;
        }
        this.classList.remove('he-category-grid--reveal');
        this._heGridConnected = false;
      }
    }

    customElements.define('he-category-grid', HECategoryGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["he-featured-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('he-featured-collection')) {
    class HEFeaturedCollection extends HTMLElement {
      connectedCallback() {
        if (this._heFcBound) return;
        this._heFcBound = true;
        this._rail = this.querySelector('[data-he-fc-rail]');
        this._prev = this.querySelector('[data-he-fc-prev]');
        this._next = this.querySelector('[data-he-fc-next]');
        if (!this._rail) return;
        this._onPrevious = () => this._scroll(-1);
        this._onNext = () => this._scroll(1);
        if (this._prev) this._prev.addEventListener('click', this._onPrevious);
        if (this._next) this._next.addEventListener('click', this._onNext);
      }
      disconnectedCallback() {
        if (this._prev && this._onPrevious) this._prev.removeEventListener('click', this._onPrevious);
        if (this._next && this._onNext) this._next.removeEventListener('click', this._onNext);
        this._heFcBound = false;
      }
      _scroll(direction) {
        if (!this._rail) return;
        const card = this._rail.querySelector('[data-he-fc-card]');
        const cardWidth = card ? card.getBoundingClientRect().width : this._rail.clientWidth * 0.8;
        const styles = window.getComputedStyle(this);
        const rtl = styles.direction === 'rtl';
        const gap = parseFloat(window.getComputedStyle(this._rail).columnGap) || 0;
        this._rail.scrollBy({ left: direction * (rtl ? -1 : 1) * (cardWidth + gap), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
    }
    customElements.define('he-featured-collection', HEFeaturedCollection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["he-hair-explorer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('he-hair-care-explorer')) {
    class HEHairCareExplorer extends HTMLElement {
      connectedCallback() {
        if (this._heInitialized) return;
        this._heInitialized = true;
        this._reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this._revealItems = Array.from(this.querySelectorAll('[data-reveal]'));

        if (this._reducedMotion || !('IntersectionObserver' in window)) {
          this._revealItems.forEach((item) => item.classList.add('is-visible'));
          return;
        }

        this.setAttribute('data-reveal-ready', 'true');
        this._observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            this._observer.unobserve(entry.target);
          });
        }, { rootMargin: '0px 0px -4% 0px', threshold: 0.08 });

        this._revealItems.forEach((item) => this._observer.observe(item));
      }

      disconnectedCallback() {
        if (this._observer) this._observer.disconnect();
        this._observer = null;
        this.removeAttribute('data-reveal-ready');
        this._heInitialized = false;
      }
    }

    customElements.define('he-hair-care-explorer', HEHairCareExplorer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["he-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('he-hero-slider')) {
    class HEHeroSlider extends HTMLElement {
      connectedCallback() {
        if (this._heHeroInitialized) return;

        this._slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
        this._previous = this.querySelector('[data-hero-previous]');
        this._next = this.querySelector('[data-hero-next]');
        this._toggle = this.querySelector('[data-hero-toggle]');
        this._currentLabel = this.querySelector('[data-hero-current]');
        this._status = this.querySelector('[data-hero-status]');
        this._progress = this.querySelector('[data-hero-progress]');
        this._interval = Math.max(3000, Number(this.dataset.interval) || 5600);
        this._autoplay = this.dataset.autoplay === 'true';
        this._pauseOnHover = true;
        this._timer = null;
        this._transitionTimer = null;
        this._userPaused = false;
        this._explicitPlay = false;
        this._hoverPaused = false;
        this._focusPaused = false;
        this._pointerStart = null;
        this._pointerInteraction = false;
        this._pointerInteractionTimer = null;
        this._heHeroInitialized = true;

        if (!this._slides.length) return;

        const initial = this._slides.findIndex((slide) => slide.classList.contains('is-active'));
        this._index = initial >= 0 ? initial : 0;
        this._motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this._reducedMotion = this._motionQuery.matches;

        this._onPrevious = () => this._show(this._index - 1, 'previous', true, true);
        this._onNext = () => this._show(this._index + 1, 'next', true, true);
        this._onToggle = () => {
          if (this._isPaused()) {
            this._userPaused = false;
            this._explicitPlay = true;
            this._hoverPaused = false;
            this._focusPaused = false;
          } else {
            this._userPaused = true;
            this._explicitPlay = false;
          }
          this._syncToggle();
          this._startRotation();
        };
        this._onPointerEnter = (event) => {
          if (!this._pauseOnHover || event.pointerType === 'touch' || !window.matchMedia('(hover: hover)').matches) return;
          this._hoverPaused = true;
          this._stopRotation();
        };
        this._onPointerLeave = (event) => {
          if (!this._pauseOnHover || event.pointerType === 'touch' || !window.matchMedia('(hover: hover)').matches) return;
          this._hoverPaused = false;
          this._startRotation();
        };
        this._onFocusIn = () => {
          if (this._pointerInteraction) return;
          this._focusPaused = true;
          this._stopRotation();
        };
        this._onFocusOut = (event) => {
          if (!this.contains(event.relatedTarget)) {
            this._focusPaused = false;
            this._startRotation();
          }
        };
        this._onVisibilityChange = () => {
          if (document.hidden) this._stopRotation();
          else this._startRotation();
        };
        this._onMotionChange = (event) => {
          this._reducedMotion = event.matches;
          if (!event.matches) this._explicitPlay = false;
          this._syncToggle();
          this._startRotation();
        };
        this._onPointerDown = (event) => {
          this._pointerInteraction = true;
          if (this._pointerInteractionTimer) window.clearTimeout(this._pointerInteractionTimer);
          this._pointerInteractionTimer = window.setTimeout(() => { this._pointerInteraction = false; }, 700);
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          if (event.target.closest('a, button, input, select, textarea')) return;
          this._pointerStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
        };
        this._onPointerUp = (event) => {
          if (this._pointerInteractionTimer) window.clearTimeout(this._pointerInteractionTimer);
          this._pointerInteractionTimer = window.setTimeout(() => { this._pointerInteraction = false; }, 0);
          if (!this._pointerStart || this._pointerStart.id !== event.pointerId) return;
          const deltaX = event.clientX - this._pointerStart.x;
          const deltaY = event.clientY - this._pointerStart.y;
          this._pointerStart = null;
          if (Math.abs(deltaX) < 48 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.2) return;
          const rtl = window.getComputedStyle(this).direction === 'rtl';
          const forward = rtl ? deltaX > 0 : deltaX < 0;
          if (forward) this._show(this._index + 1, 'next', true, true);
          else this._show(this._index - 1, 'previous', true, true);
        };
        this._onPointerCancel = () => { this._pointerStart = null; };
        this._onBlockSelect = (event) => {
          const sectionId = this.id.replace('he-hero-slider-', '');
          if (!event.detail || event.detail.sectionId !== sectionId) return;
          const selectedSlide = event.target && event.target.closest ? event.target.closest('[data-hero-slide]') : null;
          if (!selectedSlide) return;
          const index = Number(selectedSlide.dataset.index);
          if (!Number.isInteger(index)) return;
          this._stopRotation();
          this._show(index, 'next', false, false);
        };
        this._onBlockDeselect = (event) => {
          const sectionId = this.id.replace('he-hero-slider-', '');
          if (event.detail && event.detail.sectionId === sectionId) this._startRotation();
        };

        if (this._previous) this._previous.addEventListener('click', this._onPrevious);
        if (this._next) this._next.addEventListener('click', this._onNext);
        if (this._toggle) this._toggle.addEventListener('click', this._onToggle);
        this.addEventListener('pointerenter', this._onPointerEnter);
        this.addEventListener('pointerleave', this._onPointerLeave);
        this.addEventListener('focusin', this._onFocusIn);
        this.addEventListener('focusout', this._onFocusOut);
        this.addEventListener('pointerdown', this._onPointerDown, { passive: true });
        this.addEventListener('pointerup', this._onPointerUp, { passive: true });
        this.addEventListener('pointercancel', this._onPointerCancel, { passive: true });
        document.addEventListener('visibilitychange', this._onVisibilityChange);
        this.addEventListener('shopify:block:select', this._onBlockSelect);
        this.addEventListener('shopify:block:deselect', this._onBlockDeselect);
        if (typeof this._motionQuery.addEventListener === 'function') this._motionQuery.addEventListener('change', this._onMotionChange);
        else this._motionQuery.addListener(this._onMotionChange);

        this._slides.forEach((slide, index) => {
          const active = index === this._index;
          slide.classList.toggle('is-active', active);
          slide.classList.remove('is-leaving');
          slide.setAttribute('aria-hidden', String(!active));
        });
        this._loadSlide(this._index);
        if (this._slides.length > 1) this._loadSlide((this._index + 1) % this._slides.length);
        this._updateCounter();
        this._syncToggle();
        this._startRotation();
      }

      disconnectedCallback() {
        this._stopRotation();
        if (this._transitionTimer) window.clearTimeout(this._transitionTimer);
        if (this._pointerInteractionTimer) window.clearTimeout(this._pointerInteractionTimer);
        if (!this._heHeroInitialized) return;
        if (this._previous) this._previous.removeEventListener('click', this._onPrevious);
        if (this._next) this._next.removeEventListener('click', this._onNext);
        if (this._toggle) this._toggle.removeEventListener('click', this._onToggle);
        this.removeEventListener('pointerenter', this._onPointerEnter);
        this.removeEventListener('pointerleave', this._onPointerLeave);
        this.removeEventListener('focusin', this._onFocusIn);
        this.removeEventListener('focusout', this._onFocusOut);
        this.removeEventListener('pointerdown', this._onPointerDown);
        this.removeEventListener('pointerup', this._onPointerUp);
        this.removeEventListener('pointercancel', this._onPointerCancel);
        document.removeEventListener('visibilitychange', this._onVisibilityChange);
        this.removeEventListener('shopify:block:select', this._onBlockSelect);
        this.removeEventListener('shopify:block:deselect', this._onBlockDeselect);
        if (this._motionQuery) {
          if (typeof this._motionQuery.removeEventListener === 'function') this._motionQuery.removeEventListener('change', this._onMotionChange);
          else this._motionQuery.removeListener(this._onMotionChange);
        }
        this._heHeroInitialized = false;
      }

      _isPaused() {
        return !this._autoplay || this._userPaused || (this._reducedMotion && !this._explicitPlay);
      }

      _syncToggle() {
        if (!this._toggle) return;
        const paused = this._isPaused();
        this._toggle.classList.toggle('is-paused', paused);
        this._toggle.setAttribute('aria-pressed', String(paused));
        this._toggle.setAttribute('aria-label', paused ? (this.dataset.labelResume || 'Resume slideshow') : (this.dataset.labelPause || 'Pause slideshow'));
      }

      _startRotation() {
        this._stopRotation();
        if (!this._autoplay || this._slides.length < 2 || this._isPaused() || this._hoverPaused || this._focusPaused || document.hidden) return;
        
        this.classList.remove('is-rotating');
        void this.offsetWidth;
        this.classList.add('is-rotating');

        this._timer = window.setTimeout(() => {
          this._show(this._index + 1, 'next', false, false);
          this._startRotation();
        }, this._interval);
      }

      _stopRotation() {
        if (this._timer !== null && this._timer !== undefined) {
          window.clearTimeout(this._timer);
          this._timer = null;
        }
        this.classList.remove('is-rotating');
      }

      _updateCounter() {
        if (this._currentLabel) this._currentLabel.textContent = String(this._index + 1).padStart(2, '0');
      }

      _loadSlide(index) {
        const slide = this._slides[index];
        if (!slide) return;
        const picture = slide.querySelector('picture');
        const image = picture ? picture.querySelector('img') : null;
        if (!image) return;

        if (picture) {
          const mobileSource = picture.querySelector('source[data-srcset]');
          if (mobileSource) {
            mobileSource.setAttribute('srcset', mobileSource.dataset.srcset);
            delete mobileSource.dataset.srcset;
          }
        }

        if (image.dataset.srcset) {
          image.setAttribute('srcset', image.dataset.srcset.trim());
          delete image.dataset.srcset;
        }
        if (image.dataset.src) {
          image.setAttribute('src', image.dataset.src);
          delete image.dataset.src;
        }
      }

      _show(requestedIndex, direction, restartTimer, announceChange) {
        if (!this._slides || this._slides.length < 2) return;
        const nextIndex = ((requestedIndex % this._slides.length) + this._slides.length) % this._slides.length;
        if (nextIndex === this._index) {
          if (restartTimer) this._startRotation();
          return;
        }

        if (this._transitionTimer) window.clearTimeout(this._transitionTimer);
        this._slides.forEach((slide) => slide.classList.remove('is-leaving'));
        this.dataset.direction = direction;

        const oldSlide = this._slides[this._index];
        const newSlide = this._slides[nextIndex];
        this._loadSlide(nextIndex);
        oldSlide.classList.remove('is-active');
        oldSlide.classList.add('is-leaving');
        oldSlide.setAttribute('aria-hidden', 'true');
        newSlide.classList.add('is-active');
        newSlide.setAttribute('aria-hidden', 'false');
        this._index = nextIndex;
        this._loadSlide((nextIndex + 1) % this._slides.length);
        this._updateCounter();

        if (announceChange && this._status) {
          const heading = newSlide.querySelector('.he-hero-slider__heading');
          const body = newSlide.querySelector('.he-hero-slider__body');
          this._status.textContent = [heading ? heading.textContent.trim() : '', body ? body.textContent.trim() : ''].filter(Boolean).join('. ');
        }

        const duration = Math.max(0, Number.parseInt(getComputedStyle(this).getPropertyValue('--he-hero-transition'), 10) || 0) + 40;
        this._transitionTimer = window.setTimeout(() => {
          oldSlide.classList.remove('is-leaving');
          this._transitionTimer = null;
        }, duration);

        if (restartTimer) this._startRotation();
      }
    }

    customElements.define('he-hero-slider', HEHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["he-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('he-brand-story')) {
    class HEBrandStory extends HTMLElement {
      connectedCallback() {
        if (this._heStoryInitialized) return;
        this._heStoryInitialized = true;
        const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this._reducedMotion = motionQuery.matches;

        if (this.dataset.revealEnabled !== 'true' || this._reducedMotion || !('IntersectionObserver' in window)) {
          this.classList.add('he-story--visible');
          return;
        }

        this.classList.add('he-story--ready');
        this._observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            this.classList.add('he-story--visible');
            if (this._observer) this._observer.disconnect();
            this._observer = null;
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -4% 0px' });
        this._observer.observe(this);
      }

      disconnectedCallback() {
        if (this._observer) this._observer.disconnect();
        this._observer = null;
        this._heStoryInitialized = false;
      }
    }

    customElements.define('he-brand-story', HEBrandStory);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["he-ugc-rail"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('he-ugc-section')) {
    class HEUGCSection extends HTMLElement {
      connectedCallback() {
        if (this._heUGCInitialized) return;
        this.track = this.querySelector('[data-ugc-track]');
        if (!this.track) return;
        this._heUGCInitialized = true;
        this.prevButton = this.querySelector('[data-ugc-prev]');
        this.nextButton = this.querySelector('[data-ugc-next]');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.hoverPreviewEnabled = this.dataset.hoverPreview === 'true';
        this.hoverPreviewSeconds = Math.max(1, Number(this.dataset.hoverPreviewSeconds) || 3);
        this.autoplayMuted = this.dataset.autoplayMuted === 'true';
        this.loopVideo = this.dataset.loopVideo !== 'false';
        this.raf = 0;
        this.hoverTimers = new Map();
        this.hoveredCards = new Set();

        this.onClick = (event) => {
          const playButton = event.target.closest('[data-ugc-play]');
          if (!playButton || !this.contains(playButton)) return;
          event.preventDefault();
          const card = playButton.closest('[data-ugc-card]');
          if (card) this.playCard(card);
        };
        this.onPrev = () => this.step(-1);
        this.onNext = () => this.step(1);
        this.onScroll = () => {
          if (this.raf) return;
          this.raf = requestAnimationFrame(() => { this.raf = 0; this.updateNavigation(); });
        };
        this.onMotionChange = () => {
          if (this.reduceMotion.matches) {
            this.stopAllHoverTimers();
            (this.cards || []).forEach((card) => {
              if (!card._heUGCUserPlaying) this.pauseCard(card, true);
            });
          }
          this.setupAutoplay();
        };
        this.onVisibilityChange = () => {
          if (document.hidden) this.pauseAllVideos(false);
          else this.setupAutoplay();
        };

        this.addEventListener('click', this.onClick);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        if (this.prevButton) this.prevButton.addEventListener('click', this.onPrev);
        if (this.nextButton) this.nextButton.addEventListener('click', this.onNext);
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        if (this.reduceMotion.addEventListener) this.reduceMotion.addEventListener('change', this.onMotionChange);
        else this.reduceMotion.addListener(this.onMotionChange);

        this.cards = Array.from(this.querySelectorAll('[data-ugc-card]'));
        this.cards.forEach((card) => {
          const media = card.querySelector('.he-ugc__media');
          const video = card.querySelector('[data-ugc-preview]');
          if (!media || !video) return;
          card._heUGCVideo = video;
          card._heUGCUserPlaying = false;
          card._heUGCHoverPlaying = false;
          card._heUGCViewPlaying = false;
          card._heUGCOnEnded = () => this.finishCard(card);
          card._heUGCOnError = () => {
            if (card._heUGCUserPlaying || card._heUGCHoverPlaying || card._heUGCViewPlaying) this.finishCard(card);
          };
          video.addEventListener('ended', card._heUGCOnEnded);
          video.addEventListener('error', card._heUGCOnError);

          if (this.hoverPreviewEnabled) {
            card._heUGCPointerEnter = (event) => {
              if (event.pointerType === 'touch' || event.pointerType === 'pen') return;
              this.startHoverPreview(card);
            };
            card._heUGCPointerLeave = () => this.stopHoverPreview(card, true);
            media.addEventListener('pointerenter', card._heUGCPointerEnter);
            media.addEventListener('pointerleave', card._heUGCPointerLeave);
          }
        });

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.onScroll);
          this.resizeObserver.observe(this.track);
        }
        this.updateNavigation();
        this.setupAutoplay();
      }

      disconnectedCallback() {
        if (!this._heUGCInitialized) return;
        this.pauseAllVideos(true);
        this.stopAllHoverTimers();
        if (this.autoplayObserver) this.autoplayObserver.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.removeEventListener('click', this.onClick);
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
        if (this.prevButton) this.prevButton.removeEventListener('click', this.onPrev);
        if (this.nextButton) this.nextButton.removeEventListener('click', this.onNext);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        if (this.reduceMotion) {
          if (this.reduceMotion.removeEventListener) this.reduceMotion.removeEventListener('change', this.onMotionChange);
          else this.reduceMotion.removeListener(this.onMotionChange);
        }
        (this.cards || []).forEach((card) => {
          const media = card.querySelector('.he-ugc__media');
          const video = card._heUGCVideo;
          if (media && card._heUGCPointerEnter) media.removeEventListener('pointerenter', card._heUGCPointerEnter);
          if (media && card._heUGCPointerLeave) media.removeEventListener('pointerleave', card._heUGCPointerLeave);
          if (video && card._heUGCOnEnded) video.removeEventListener('ended', card._heUGCOnEnded);
          if (video && card._heUGCOnError) video.removeEventListener('error', card._heUGCOnError);
        });
        cancelAnimationFrame(this.raf);
        this._heUGCInitialized = false;
      }

      activateSources(video) {
        let changed = false;
        video.querySelectorAll('source[data-src]').forEach((source) => {
          if (!source.getAttribute('src')) {
            source.setAttribute('src', source.dataset.src);
            changed = true;
          }
        });
        if (changed) video.load();
      }

      async playCard(card) {
        const video = card._heUGCVideo || card.querySelector('[data-ugc-preview]');
        if (!video) return;
        this.stopAllHoverTimers();
        (this.cards || []).forEach((otherCard) => {
          if (otherCard !== card && otherCard._heUGCUserPlaying) this.finishCard(otherCard);
        });
        this.pauseAllVideos(false, card);
        this.activateSources(video);
        card._heUGCUserPlaying = true;
        card._heUGCHoverPlaying = false;
        card._heUGCViewPlaying = false;
        const playButton = card.querySelector('[data-ugc-play]');
        if (playButton) { playButton.setAttribute('aria-hidden', 'true'); playButton.tabIndex = -1; }
        video.muted = false;
        video.controls = true;
        video.playsInline = true;
        video.loop = this.loopVideo;
        card.classList.remove('is-previewing', 'is-hover-preview');
        card.classList.add('is-playing');
        try {
          await video.play();
        } catch (error) {
          this.finishCard(card);
        }
      }

      finishCard(card) {
        const video = card._heUGCVideo || card.querySelector('[data-ugc-preview]');
        if (!video) return;
        video.pause();
        try { video.currentTime = 0; } catch (error) {}
        video.controls = false;
        video.muted = true;
        card._heUGCUserPlaying = false;
        card._heUGCHoverPlaying = false;
        card._heUGCViewPlaying = false;
        const playButton = card.querySelector('[data-ugc-play]');
        if (playButton) { playButton.removeAttribute('aria-hidden'); playButton.tabIndex = 0; }
        card.classList.remove('is-playing', 'is-previewing', 'is-hover-preview');
      }

      pauseCard(card, reset = false) {
        const video = card._heUGCVideo || card.querySelector('[data-ugc-preview]');
        if (!video) return;
        video.pause();
        if (reset) {
          try { video.currentTime = 0; } catch (error) {}
        }
        if (!card._heUGCUserPlaying) {
          card.classList.remove('is-previewing', 'is-hover-preview');
          card._heUGCHoverPlaying = false;
          card._heUGCViewPlaying = false;
          video.controls = false;
          video.muted = true;
        }
      }

      pauseAllVideos(reset = false, exceptCard = null) {
        (this.cards || []).forEach((card) => {
          if (card === exceptCard) return;
          this.pauseCard(card, reset);
        });
      }

      setupAutoplay() {
        if (this.autoplayObserver) this.autoplayObserver.disconnect();
        this.autoplayObserver = null;
        /* If timed hover previews are enabled, they take priority over viewport autoplay. */
        if (!this.autoplayMuted || this.hoverPreviewEnabled || this.reduceMotion.matches || !('IntersectionObserver' in window)) return;

        this.autoplayObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const card = entry.target;
            const video = card._heUGCVideo;
            if (!video || card._heUGCUserPlaying) return;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.25 && !document.hidden) {
              this.pauseAllVideos(false, card);
              this.activateSources(video);
              video.muted = true;
              video.controls = false;
              video.loop = this.loopVideo;
              card._heUGCViewPlaying = true;
              const promise = video.play();
              if (promise && typeof promise.then === 'function') {
                promise.then(() => { if (card._heUGCViewPlaying && !card._heUGCUserPlaying) card.classList.add('is-previewing'); }).catch(() => card.classList.remove('is-previewing'));
              }
            } else if (card._heUGCViewPlaying) {
              this.pauseCard(card, true);
            }
          });
        }, { root: null, rootMargin: '80px 0px', threshold: [0, 0.25, 0.5] });

        (this.cards || []).forEach((card) => {
          if (card._heUGCVideo && !card._heUGCUserPlaying) this.autoplayObserver.observe(card);
        });
      }

      startHoverPreview(card) {
        if (!this.hoverPreviewEnabled || this.reduceMotion.matches || document.hidden || card._heUGCUserPlaying) return;
        const video = card._heUGCVideo;
        if (!video) return;
        this.stopAllHoverTimers();
        this.pauseAllVideos(true, card);
        this.activateSources(video);
        video.muted = true;
        video.controls = false;
        video.loop = false;
        try { video.currentTime = 0; } catch (error) {}
        card._heUGCHoverPlaying = true;
        card._heUGCViewPlaying = false;
        card.classList.remove('is-previewing');
        card.classList.add('is-hover-preview');
        const promise = video.play();
        if (promise && typeof promise.then === 'function') {
          promise.then(() => {
            if (!card._heUGCHoverPlaying || card._heUGCUserPlaying) return;
            const timer = window.setTimeout(() => this.stopHoverPreview(card, true), this.hoverPreviewSeconds * 1000);
            this.hoverTimers.set(card, timer);
          }).catch(() => this.stopHoverPreview(card, true));
        } else {
          const timer = window.setTimeout(() => this.stopHoverPreview(card, true), this.hoverPreviewSeconds * 1000);
          this.hoverTimers.set(card, timer);
        }
      }

      stopHoverPreview(card, reset = true) {
        const timer = this.hoverTimers.get(card);
        if (timer) window.clearTimeout(timer);
        this.hoverTimers.delete(card);
        if (!card || !card._heUGCHoverPlaying || card._heUGCUserPlaying) return;
        this.pauseCard(card, reset);
      }

      stopAllHoverTimers() {
        this.hoverTimers.forEach((timer) => window.clearTimeout(timer));
        this.hoverTimers.clear();
        (this.cards || []).forEach((card) => {
          if (card._heUGCHoverPlaying && !card._heUGCUserPlaying) this.pauseCard(card, true);
        });
      }

      step(direction) {
        if (!this.track) return;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const amount = Math.max(220, this.track.clientWidth * 0.82);
        this.track.scrollBy({ left: amount * direction * (rtl ? -1 : 1), behavior: this.reduceMotion.matches ? 'auto' : 'smooth' });
      }

      updateNavigation() {
        const nav = this.querySelector('[data-ugc-navigation]');
        if (!nav || this.dataset.layout !== 'rail' || !this.track) return;
        nav.hidden = this.track.scrollWidth <= this.track.clientWidth + 2;
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const current = Math.abs(this.track.scrollLeft);
        if (this.prevButton) this.prevButton.disabled = current <= 2;
        if (this.nextButton) this.nextButton.disabled = current >= max - 2;
      }
    }
    customElements.define('he-ugc-section', HEUGCSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-rail"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('he-product-rail')) {
    class HeProductRail extends HTMLElement {
      connectedCallback() {
        if (this._heInitialized) return;
        this._heInitialized = true;
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;

        this.nav = this.querySelector('[data-nav]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.raf = 0;

        this.onScroll = () => {
          if (this.raf) return;
          this.raf = requestAnimationFrame(() => {
            this.raf = 0;
            this.updateNavigation();
          });
        };
        this.onPrev = () => this.step(-1);
        this.onNext = () => this.step(1);
        this.onQuickClick = (event) => event.stopPropagation();
        this.quickZones = Array.from(this.querySelectorAll('[data-quick-zone]'));

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        if (this.prev) this.prev.addEventListener('click', this.onPrev);
        if (this.next) this.next.addEventListener('click', this.onNext);
        this.quickZones.forEach((zone) => zone.addEventListener('click', this.onQuickClick));

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.onScroll);
          this.resizeObserver.observe(this.track);
        }

        this.setQuickAddAccessibleNames();
        this.setupReveal();
        this.updateNavigation();
      }

      disconnectedCallback() {
        if (!this._heInitialized) return;
        if (this.track && this.onScroll) this.track.removeEventListener('scroll', this.onScroll);
        if (this.prev && this.onPrev) this.prev.removeEventListener('click', this.onPrev);
        if (this.next && this.onNext) this.next.removeEventListener('click', this.onNext);
        if (this.quickZones && this.onQuickClick) this.quickZones.forEach((zone) => zone.removeEventListener('click', this.onQuickClick));
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.intersectionObserver) this.intersectionObserver.disconnect();
        if (this.raf) cancelAnimationFrame(this.raf);
        this._heInitialized = false;
      }

      setQuickAddAccessibleNames() {
        this.querySelectorAll('.he-card__quick .quick-add__button').forEach((button) => {
          if (!button.hasAttribute('aria-label')) {
            const label = button.textContent.replace(/\s+/g, ' ').trim();
            if (label) button.setAttribute('aria-label', label);
          }
        });
      }

      step(direction) {
        if (!this.track) return;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const distance = Math.max(180, this.track.clientWidth * 0.82);
        this.track.scrollBy({
          left: distance * direction * (rtl ? -1 : 1),
          behavior: this.reduceMotion ? 'auto' : 'smooth'
        });
      }

      updateNavigation() {
        if (!this.track || !this.nav) return;
        const overflow = this.track.scrollWidth - this.track.clientWidth > 3;
        const desktopLayout = this.dataset.layout;
        const mobileLayout = this.dataset.mobileLayout;
        const mobile = window.matchMedia('(max-width: 749px)').matches;
        const railActive = mobile ? mobileLayout === 'rail' : desktopLayout === 'rail';
        this.nav.hidden = !overflow || !railActive;
      }

      setupReveal() {
        if (this.reduceMotion || !('IntersectionObserver' in window) || !this.track) return;
        const items = Array.from(this.track.querySelectorAll('.he-rail__item'));
        if (!items.length) return;
        this.intersectionObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.remove('is-pending');
            this.intersectionObserver.unobserve(entry.target);
          });
        }, { rootMargin: '0px 0px -4% 0px', threshold: 0.08 });
        items.forEach((item) => {
          item.classList.add('is-pending');
          this.intersectionObserver.observe(item);
        });
      }
    }
    customElements.define('he-product-rail', HeProductRail);
  }

  } catch(e) { console.error(e); }
})();
})();
